/**
 * Login page for `flow-web --token`: POSTs /api/login {token}; the server
 * answers 204 and sets the `flow_web_token` cookie. Redirects to ?next.
 */
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { login } from "@/api/client";

export default function LoginView() {
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const next = params.get("next") ?? "/";
  return (
    <div className="flex h-full items-center justify-center bg-bg">
      <form
        className="flex w-80 flex-col gap-2 rounded-sm border border-border bg-bg-elev p-4"
        onSubmit={(e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          login(token)
            .then((ok) => {
              if (ok) void navigate(next.startsWith("/") ? next : "/", { replace: true });
              else setError("Token rejected");
            })
            .catch((err: unknown) => setError(err instanceof Error ? err.message : "login failed"))
            .finally(() => setBusy(false));
        }}
      >
        <h1 className="text-sm font-semibold">flow-web</h1>
        <p className="text-fg-muted">This server requires the shared token (`--token`).</p>
        <input
          className="ctl"
          type="password"
          placeholder="token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          autoFocus
          aria-label="token"
        />
        {error && <div className="text-danger">{error}</div>}
        <button type="submit" className="ctl on" disabled={busy || !token}>
          {busy ? "…" : "sign in"}
        </button>
      </form>
    </div>
  );
}
